export const getAllCountriesEndpoint = 'countries';
